import { request } from '../request';
import { otherRequest } from '../request';

export function fetchGetMockList(data: any) {
  return request({
    url: '/developer-platform/api/device/mock/page',
    method: 'POST',
    data,
  });
}


export function fetchAddMock(data?: Api.Product.ProductParams) {
  return request({
    url: '/developer-platform/api/device/mock/add',
    method: 'POST',
    data,
  });
}

export function fetchDelMock(data: any) {
  return request({
    url: '/developer-platform/api/device/mock/delete',
    method: 'POST',
    data,
  });
}

export function fetchGetMockDetail(params: any) {
  return request({
    url: '/developer-platform/api/device/mock/detail',
    method: 'GET',
    params
  });
}

export function fetchDelPreset(data: any) {
  return request({
    url: '/developer-platform/api/device/mock/function/default/delete',
    method: 'POST',
    data,
  });
}

export function fetchGetPresetList(params: any) {
  return request({
    url: '/developer-platform/api/device/mock/function/default/list',
    method: 'GET',
    params
  });
}

export function fetchSavePreset(data?: Api.Product.ProductParams) {
  return request({
    url: '/developer-platform/api/device/mock/function/default/save',
    method: 'POST',
    data,
  });
}

export function fetchLoginBucket(data: any) {
  return request({
    url: "/api/bucket/login",
    method: 'POST',
    data,
  });
}

export function fetchGetConnectBucket(params: any, token: string) {
  return request({
    url: "/api/bucket/getConnectBucket",
    method: 'GET',
    headers: {
      token
    },
    params
  });
}

export function fetchGetCode(params: any, data: any) {
  return otherRequest({
    url: "/gvs/third/qrCode/save",
    method: 'post',
    params,
    data
  });
}
